import { CategoryDto } from "../types/category";
import { Post } from "../types/post";

export const exactHumanUnlockTime = (category: CategoryDto) => {
  const days = category?.days_to_unlock;
  if (days == null) return;

  if (days < 0) {
    throw new Error("La cantidad de días no puede ser negativa");
  }

  // Mostrar en años si es divisible por 365
  if (days % 365 === 0) {
    const years = days / 365;
    return `Se desbloqueará en ${years} año${years === 1 ? "" : "s"}`;
  }

  // Mostrar en meses si es divisible por 30
  if (days % 30 === 0) {
    const months = days / 30;
    return `Se desbloqueará en ${months} mes${months === 1 ? "" : "es"}`;
  }

  // Mostrar en semanas si es divisible por 7
  if (days % 7 === 0) {
    const weeks = days / 7;
    return `Se desbloqueará en ${weeks} semana${weeks === 1 ? "" : "s"}`;
  }

  // En todos los demás casos, mostrar en días
  return `Se desbloqueará en ${days} día${days === 1 ? "" : "s"}`;
}

export const roundedHumanUnlockTime = (category: CategoryDto) => {
  if (category?.user_access_data?.is_unlocked) {
    return "🎉 Categoria desbloqueada";
  }

  const days = category?.user_access_data?.days_remaining_to_unlock;
  if (days == null) return;

  if (days < 0) {
    throw new Error("La cantidad de días no puede ser negativa");
  }

  if (days <= 90) {
    return `Se desbloqueará en ${days} día${days === 1 ? "" : "s"}`;
  }

  const months = Math.round(days / 30);
  return `Se desbloqueará en ${months} mes${months === 1 ? "" : "es"}`;
}

export const roundedHumanPostUnlockTime = (post: Post) => {
  if (post?.user_access_data?.is_unlocked) {
    return "🎉 Categoria desbloqueada";
  }

  const days = post?.user_access_data?.days_remaining_to_unlock;
  if (days == null) return;

  if (days < 0) {
    throw new Error("La cantidad de días no puede ser negativa");
  }

  if (days <= 90) {
    return `${days} día${days === 1 ? "" : "s"}`;
  }

  const months = Math.round(days / 30);
  return `${months} mes${months === 1 ? "" : "es"}`;
}




export const roundedToUnlockCategoryTime = (category: CategoryDto) => {
  const days = category?.days_to_unlock;
  if (days == null) return;

  if (days < 0) {
    console.error("La cantidad de días no puede ser negativa");
    return 'NaN'
  }

  if (days <= 90) {
    return `${days} día${days === 1 ? "" : "s"}`;
  }

  const months = Math.round(days / 30);
  return `${months} mes${months === 1 ? "" : "es"}`;
}